import { canCarry } from '../../../game/demo/inventory/capacity';
import { ItemId } from '../../../game/demo/inventory/items';
import { InventoryEffect, InventoryState } from './inventory.model';

type EffectHandler = (state: InventoryState, effect: InventoryEffect) => InventoryState;

const handlers: { [K in InventoryEffect['type']]: EffectHandler } = {
  grant: (state, effect) => {
    if (effect.type !== 'grant') return state;
    // All-or-nothing: if the whole grant would push past carry capacity, refuse
    // it entirely (you cannot pick up what you cannot carry).
    if (!canCarry(state, effect.item, effect.quantity)) return state;
    const current = state.items[effect.item] ?? 0;
    return { items: { ...state.items, [effect.item]: current + effect.quantity } };
  },
  consume: (state, effect) => {
    if (effect.type !== 'consume') return state;
    const current = state.items[effect.item] ?? 0;
    const next = Math.max(current - effect.quantity, 0);
    if (next === current) return state;
    return { items: { ...state.items, [effect.item]: next } };
  },
};

export const applyEffect = (state: InventoryState, effect: InventoryEffect): InventoryState =>
  handlers[effect.type](state, effect);

export const getItemQuantity = (state: InventoryState, id: ItemId): number => state.items[id] ?? 0;
